import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { compareMonths: { compareMonths } } = apiUrls;

export const COMPARE_MONTHS_SALES_SUCCESS = 'COMPARE_MONTHS_SALES_SUCCESS';

export const COMPARE_MONTHS_LOADING = 'COMPARE_MONTHS_LOADING';


export const getCompareMonthData = ({ from, to, vendor }) => async (dispatch) => {
  try {
    if (vendor) {
      const requestData = { ...compareMonths, url: compareMonths.url.replace('{{vendor}}', vendor)
      .replace('{from}', from).replace('{to}', to) }       
      const data = await REQUEST(requestData);
      dispatch({
        type: COMPARE_MONTHS_SALES_SUCCESS,
        data,
        vendor
      })
    }

  } catch (e) {

    dispatch({
      type: COMPARE_MONTHS_SALES_SUCCESS,
      data: {
        code: "",
        modal: null,
        notifications: null,
        paginationInfo: null
      },
      vendor
    })
  }

}

export const handleLoader = (isLoading, vendor) => (dispatch) => {

  if (vendor) {
    dispatch({
      type: COMPARE_MONTHS_LOADING,
      isLoading,
      vendor
    })
  }
}